import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import plugins from '@/utils/plugins';
Vue.use(plugins);
Vue.config.productionTip = false;
// common.css
import '@/assets/css/common.css';
import 'amfe-flexible'; //引入rem自适应
import  '@vant/touch-emulator';
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  document.documentElement.scrollTop = 0;
 if(to.params.id){
  let shopId = decodeURIComponent(to.params.id);
  window.extra_shop_id = shopId;
 }
  next();
});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
